/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SensorHistory model module.
* @module model/SensorHistory
* @version 2020-12-7
*/
export default class SensorHistory {
    /**
    * Constructs a new <code>SensorHistory</code>.
    * タンクの交換履歴
    * @alias module:model/SensorHistory
    * @class
    * @param timestamp {Number} 時刻
    * @param sensorId {Number} センサーID
    * @param serialNo {String} シリアルNo
    */

    constructor(timestamp, sensorId, serialNo) {
        
        
        this['timestamp'] = timestamp;
        this['sensorId'] = sensorId;
        this['serialNo'] = serialNo;
        
    }

    /**
    * Constructs a <code>SensorHistory</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SensorHistory} obj Optional instance to populate.
    * @return {module:model/SensorHistory} The populated <code>SensorHistory</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SensorHistory();
                        
            
            if (data.hasOwnProperty('timestamp')) {
                obj['timestamp'] = ApiClient.convertToType(data['timestamp'], 'Number');
            }
            if (data.hasOwnProperty('sensorId')) {
                obj['sensorId'] = ApiClient.convertToType(data['sensorId'], 'Number');
            }
            if (data.hasOwnProperty('serialNo')) {
                obj['serialNo'] = ApiClient.convertToType(data['serialNo'], 'String');
            }
        }
        return obj;
    }

    /**
    * 時刻
    * @member {Number} timestamp
    */
    'timestamp' = undefined;
    /**
    * センサーID
    * @member {Number} sensorId
    */
    'sensorId' = undefined;
    /**
    * シリアルNo
    * @member {String} serialNo
    */
    'serialNo' = undefined;




}
